export default __webpack_public_path__ + "static/media/TargetImg.93146f2f.svg";